module.exports = require("/home/milena/Desktop/Exercise/blog/src/utils/typography")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 453
// module chunks = 231608221292675